import {
  FormLabel,
  FormControl,
  FormErrorMessage,
  InputProps,
} from '@chakra-ui/react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { TimeInput } from './TimeInput';

interface ITimeInputWithScaleProps extends InputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  defaultCountryCode?: string;
  name: string;
  label?: string;
  error?: FieldError;
}

export const TimeInputWithScale = ({
  control,
  isDisabled,
  error,
  label,
  name,
  ...rest
}: ITimeInputWithScaleProps): JSX.Element => (
  <FormControl isInvalid={!!error}>
    {!!label && <FormLabel htmlFor={name}>{label}</FormLabel>}

    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value } }) => (
        <TimeInput
          {...rest}
          onChangeTimeValue={onChange}
          onBlur={onBlur}
          value={value}
          isDisabled={isDisabled}
        />
      )}
    />

    {!!error && (
      <FormErrorMessage position="absolute">{error.message}</FormErrorMessage>
    )}
  </FormControl>
);
